import { atom } from "@reatom/framework";

export const productDetailModalAtom = atom(false, "productDetailModal");
